<template>
  <div class="q-mb-lg">
    <div class="q-subheading text-bold text-blue-grey-4">{{ dateFormatted }}</div>

    <div class="bg-white generic-border round-borders overflow-hidden q-mt-sm">
      <list-entry v-for="timeEntry in timeEntries" :key="timeEntry.id" :time-entry="timeEntry" :showUser="showUser"/>
    </div>
  </div>
</template>

<script>
  import ListEntry from './ListEntry.vue'
  import { distanceInWordsOrFormat } from 'src/utils/date'
  import isSameYear from 'date-fns/is_same_year'
  import parseDate from 'date-fns/parse'

  export default {
    props: {
      date: {
        type: String,
        required: true
      },

      timeEntries: {
        type: Array,
        required: true
      },

      showUser: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      dateFormatted () {
        const format = isSameYear(parseDate(this.date), Date.now()) ? 'dddd, DD. MMMM' : 'dddd, DD. MMMM YYYY'

        return distanceInWordsOrFormat(this.date, 1, format)
      }
    },

    components: {
      ListEntry
    }
  }
</script>
